
import React from 'react';
import Popup from 'reactjs-popup';
import { Button } from 'primereact/button';

import { Card } from 'primereact/card';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import './styles.css';
import Pdf from '../pdf/index';

const PPdf = props => {
    const header = <img alt="Card" src={fundo_amarelo} />;

    return (
        <Popup modal
            trigger={
                <Button type="submit" label="Imprimir" ></Button>
            }>
            {close => (
                <div className="modal">
                    <div className="content">
                        <Card className='tratar-scroll-card' header={header} title="Imprimir contrato">
                            <>
                                <Pdf props={props} />
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-3 p-lg-3 p-sm-3" >
                                        <Button type="submit" label="Fechar" onClick={close} ></Button>
                                        <br /><br />
                                    </div>
                                </div>
                            </>
                        </Card>
                    </div>
                </div>
            )}
        </Popup>
    );
};

export default PPdf;
